"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FourPdaError = void 0;
exports.extractWireErrorMessage = extractWireErrorMessage;
exports.describeWireStatus = describeWireStatus;
/** Известные глобальные коды ошибок 4PDA */
const GLOBAL_ERRORS = {
    1: 'Внутренняя ошибка сервера 4PDA',
    2: 'Доступ запрещен (требуется авторизация)',
    3: 'Неверные аргументы запроса',
    4: 'Требуется ввод капчи',
};
/** Коды ошибок для конкретных команд */
const COMMAND_ERRORS = {
    'mi': {
        3: 'Пользователь не найден или нет доступа к профилю',
    },
    'fr': {
        3: 'Тема не найдена (удалена или поглощена при объединении)',
    },
    'fu': {
        2: 'Ошибка инициализации загрузки (неверный протокол)',
        6: 'Размер файла превышает допустимый лимит (192 МБ)',
        7: 'Этот тип файла запрещен для загрузки на сервер 4PDA',
    },
    'su': {
        1: 'Внутренняя ошибка при передаче потока',
        2: 'Передача потока запрещена',
        6: 'Размер файла превышает допустимый лимит (192 МБ)',
        7: 'Этот тип файла запрещен для загрузки на сервер 4PDA',
    },
    'ta': {
        2: 'Ошибка ограничений или прав доступа (например, жалоба на собственный пост, повторная жалоба, или отсутствие прав в разделе)',
        3: 'Целевой объект не найден',
        4: 'Текст жалобы слишком короткий',
    },
    'bc': {
        2: 'Ошибка ограничений (например, жалоба на этот пост уже создана и находится на рассмотрении, или сработал флуд-контроль)',
        3: 'Целевой объект не найден',
        4: 'Текст жалобы слишком короткий',
        6: 'Доступ запрещен (требуется авторизация)',
    },
    'qp': {
        3: 'Невозможно отправить сообщение: получатель не найден, либо вы находитесь у него в Черном Списке.',
    },
    'qb': {
        3: 'Невозможно добавить пользователя в Черный Список (например, это модератор или администратор).',
    },
    'md': {
        4: 'Нельзя добавить более 5 устройств',
    },
    'ts': {
        5: 'Не удалось сменить статус тикета (конфликт ответственного или неверные параметры)',
    },
    'mw': {
        5: 'Не указана причина',
        6: 'Не указано сообщение',
        7: 'Уровень предупреждений уже максимален',
        8: 'УП этого пользователя уже повышали за последние 5 часов',
    },
    'sk': {
        3: 'Нельзя выполнить действие (уже скрыт или поставлен плюс в карму)',
    },
    'fw': {
        2: 'Недостаточно прав для создания темы в этом разделе',
        3: 'В этом разделе нельзя создавать новые темы (архив, каталог или ограничение раздела)',
    },
    'mr': {
        4: 'Изменение репутации заблокировано',
        5: 'Вы не можете менять репутацию самому себе',
        6: 'У вас недостаточно постов, чтобы менять репутацию',
        7: 'У вас слишком низкая репутация',
        8: 'Вы больше не можете менять репутацию сегодня',
        9: 'Вы больше не можете менять репутацию этому человеку сегодня',
        10: 'Вы больше не можете менять репутацию за этот пост',
        11: 'В данный момент вы не можете изменить репутацию этому человеку',
        12: 'Изменение отклонено: вы недавно ставили минус этому человеку',
        13: 'Изменение отклонено: пользователь недавно поставил вам минус',
    },
};
function extractWireErrorMessage(data) {
    if (!data)
        return null;
    if (typeof data === 'string')
        return data;
    if (Array.isArray(data)) {
        if (data.length > 1) {
            const nested = data[1];
            if (typeof nested === 'string' && nested.trim())
                return nested.trim();
            if (Array.isArray(nested)) {
                for (const part of nested) {
                    if (typeof part === 'string' && part.trim())
                        return part.trim();
                }
            }
        }
        for (const item of data) {
            if (typeof item === 'string' && item.trim())
                return item.trim();
            if (Array.isArray(item)) {
                const subItem = extractWireErrorMessage(item);
                if (subItem)
                    return subItem;
            }
        }
    }
    return null;
}
/**
 * Человекочитаемое описание wire-status (и вложенного сообщения сервера в data).
 * Используется в FourPdaError, CLI и отладочных скриптах.
 */
function describeWireStatus(code, command = '', data) {
    const serverError = extractWireErrorMessage(data);
    if (serverError)
        return serverError;
    const cmdErrors = COMMAND_ERRORS[command];
    if (cmdErrors && cmdErrors[code])
        return cmdErrors[code];
    if (GLOBAL_ERRORS[code])
        return GLOBAL_ERRORS[code];
    const cmdLabel = command ? `'${command}'` : 'wire';
    return `Ошибка выполнения команды ${cmdLabel} на сервере 4PDA (код ${code})`;
}
class FourPdaError extends Error {
    constructor(code, command, message, data) {
        const text = message || describeWireStatus(code, command, data);
        super(text);
        this.name = 'FourPdaError';
        this.code = code;
        this.command = command;
        this.data = data;
    }
}
exports.FourPdaError = FourPdaError;
